// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2ByjO","additionalInfo":"AgreementModal_additionalInfo__3APAb"};